$(document).ready(function () {
    var canvas = document.getElementById('CustomizerCanvas');
    var ctx = canvas.getContext('2d');

    //get url parameter
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    var name_parm = getUrlParameter('name');
    var save_id = getUrlParameter('id');

    //get shopify custom properties or url params
    if (name_parm == false) {
        var name = document.getElementById('name').value;
        var digit_one = document.getElementById('number1').value;
        var digit_one_style = document.getElementById('number1_style').value;
        var digit_two = document.getElementById('number2').value;
        var digit_two_style = document.getElementById('number2_style').value;
        var size_id = $('.select-size').val();
    } else if (name_parm !== false && save_id == false) {
        var name = getUrlParameter('name');
        var digit_one = getUrlParameter('num1');
        var digit_one_style = getUrlParameter('num1_style');
        var digit_two = getUrlParameter('num2');
        var digit_two_style = getUrlParameter('num2_style');
        var size_id = getUrlParameter('size');
    }else {
        var name = getUrlParameter('name');
        var digit_one = getUrlParameter('num1');
        var digit_one_style = getUrlParameter('num1_style');
        var digit_two = getUrlParameter('num2');
        var digit_two_style = getUrlParameter('num2_style');
        var size_id = getUrlParameter('size');
        var main_id = getUrlParameter('id');
    }

    // pass values to customizer input fields
    $('#CustomizerName').val(name);
    $('#CustomizerDigit1').val(digit_one);
    $('#CustomizerDigit2').val(digit_two);

    // digit 1 style on click
    $('.tab_digit_one_row .tab_digit_block').click(function () {
        var item = $(this);
        var style = item.data('style');
        var digit = item.data('digit');
        //remove and add active block class
        $('.tab_digit_one_row .tab_digit_block').removeClass('current_num');
        item.addClass('current_num');
        //add digit style to shopify custom property
        $('#number1_style').val(style);
        // check values of custom properties to determine if add to cart / save for later btns can be activated
        setTimeout(function () {
            cartSaveBtnsValidation();
        }, 300);
        //create 1st digit on jersey
        createCanvas1stDigit(style, digit);
    });

    // digit 2 style on click
    $('.tab_digit_two_row .tab_digit_block').click(function () {
        var item = $(this);
        var style = item.data('style');
        var digit = item.data('digit');
        //remove and add active block class
        $('.tab_digit_two_row .tab_digit_block').removeClass('current_num');
        item.addClass('current_num');
        //add digit style to shopify custom property
        $('#number2_style').val(style);
        //create 1st digit on jersey
        createCanvas2ndDigit(style, digit);
    });

    // check values of custom properties to determine if add to cart / save for later btns can be activated
    function cartSaveBtnsValidation() {
        var name_input = document.getElementById('CustomizerName').value;
        var digit_one_input = document.getElementById('CustomizerDigit1').value;
        var digit_one_style_input = document.getElementById('number1_style').value;

        if (name_input == '' || digit_one_input == '' || digit_one_style_input == '') {
            $('#save_for_later_btn').css({ 'pointer-events': 'none', cursor: 'none', 'background-color': '#d19ba5' });
            $('#AddToCart').css({ 'pointer-events': 'none', cursor: 'none', 'background-color': '#d19ba5' });
        } else {
            $('#save_for_later_btn').css({ 'pointer-events': 'auto', cursor: 'pointer', 'background-color': '#961a30' });
            $('#AddToCart').css({ 'pointer-events': 'auto', cursor: 'pointer', 'background-color': '#961a30' });
        }
    }
    // check if product is on sale
    function checkIfProductIsOnSale() {
        var check = $('#check_sale').val();
        var customizer_check = $('#customizer-product').val();

        if (check === '' && customizer_check === 'customizer') {
            $('#AddToCart').css({ display: 'none' });
        } else {
            $('#AddToCart').css({ display: 'block' });
        }
    }
    //1st digit canvas creation
    function createCanvas1stDigit(style, digit) {
        ctx.imageSmoothingQuality = "high";
      
        ctx.clearRect(115, 310, 115, 300);
        var digit1Back = new Image();
        digit1Back.src = 'https://iamheatnation.com/shopify-mashup-jersey-app/assets/img/font-images/' + style + '/' + digit + '.png';
        digit1Back.onload = function () {
            ctx.drawImage(digit1Back, 120, 310, 120, 120);
        };

        ctx.clearRect(524, 260, 55, 300);
        var digit1Front = new Image();
        digit1Front.src = 'https://iamheatnation.com/shopify-mashup-jersey-app/assets/img/font-images/' + style + '/' + digit + '.png';
        digit1Front.onload = function () {
            ctx.drawImage(digit1Front, 524, 260, 60, 60);
        };
    }
    //2nd digit canvas creation
    function createCanvas2ndDigit(style, digit) {
        ctx.imageSmoothingQuality = "high";
      
        ctx.clearRect(230, 310, 100, 300);
        var digit2Back = new Image();
        digit2Back.src = 'https://iamheatnation.com/shopify-mashup-jersey-app/assets/img/font-images/' + style + '/' + digit + '.png';
        digit2Back.onload = function () {
            ctx.drawImage(digit2Back, 220, 310, 120, 120);
        };

        ctx.clearRect(578, 260, 60, 300);
        var digit2Front = new Image();
        digit2Front.src = 'https://iamheatnation.com/shopify-mashup-jersey-app/assets/img/font-images/' + style + '/' + digit + '.png';
        digit2Front.onload = function () {
            ctx.drawImage(digit2Front, 578, 260, 60, 60);
        };
    }

    //shift canvas if jersey only has 1 digit
    function shiftCanvasIfOneDigit() {
        if (digit_two == '') {
            document.getElementById('CustomizerCanvas').style.left = '7.5%';
        } else {
            document.getElementById('CustomizerCanvas').style.left = '2.5%';
        }
    }

    // customizer input fields key event listeners
    function customizerKeyEvents() {
        // name input
        $('#CustomizerName').keyup(function () {
            $(this).val($(this).val().toUpperCase());
            var name = $(this).val();
            // pass value to shopify property
            $('#name').val(name);
            // check if cart and save buttons can be activated
            cartSaveBtnsValidation();
        });

        //2nd digit input,
        $('#CustomizerDigit2').keydown(function (e) {
            if (e.keyCode == 8) {
                ctx.clearRect(235, 310, 100, 300);
                ctx.clearRect(578, 255, 60, 300);

                // remove active style
                $('.tab_digit_two_row .tab_digit_block').removeClass('current_num');
                //clear value of shopify property
                $('#number2_style').val('');
                // hide all digit style rows
                $('.tab_digit_two_row .tab_digit_row[data-row-digit]').hide();
            }
        });

        // 2nd digit input, if user inputs 2nd digit shift canvas and show 2nd digit row
        $('#CustomizerDigit2').keyup(function () {
            var digit2 = $(this).val();
            $('#number2').val(digit2);
            $('.tab_digit_two_row .tab_digit_row[data-row-digit]').hide();
            $('.tab_digit_two_row .tab_digit_row[data-row-digit="' + digit2 + '"]').show();
            if ($('#number2').val() == '') {
                document.getElementById('CustomizerCanvas').style.left = '50px';
            } else {
                document.getElementById('CustomizerCanvas').style.left = '6px';
            }
        });

        //1st digit, if user inputs backspaces clear from jersey and hide 2nd digit style row
        $('#CustomizerDigit1').keydown(function (e) {
            if (e.keyCode == 8) {
                ctx.clearRect(120, 310, 115, 300);
                ctx.clearRect(528, 255, 53, 300);
                // remove active style
                $('.tab_digit_one_row .tab_digit_block').removeClass('current_num');
                //clear value of shopify property
                $('#number1_style').val('');
                // hide all digit style rows
                $('.tab_digit_one_row .tab_digit_row[data-row-digit]').hide();
            }
        });

        // 1st digit, shift canvas if 2nd digit empty
        $('#CustomizerDigit1').keyup(function () {
            var digit1 = $(this).val();
            // pass value to shopify property
            $('#number1').val(digit1);
            // show correct digit style row
            $('.tab_digit_one_row .tab_digit_row[data-row-digit]').hide();
            $('.tab_digit_one_row .tab_digit_row[data-row-digit="' + digit1 + '"]').show();
            // check if cart and save buttons can be activated
            cartSaveBtnsValidation();
        });

        // 1 digit and 2 digit, only allow digits
        $('#CustomizerDigit1, #CustomizerDigit2').keypress(function (e) {
            //if the letter is not digit then display error and don't type anything
            if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
                return false;
            }
        });
    }

    //Check player specific jersey, disable input fields and shift canvas depending if player has 1 or 2 digits
    var check_player = $('#players_specific').val();
    if (check_player === 'players-product') {
        $('#CustomizerDigit1').attr('disabled', 'disabled');
        $('#CustomizerDigit2').attr('disabled', 'disabled');
        $('#CustomizerName').attr('disabled', 'disabled');
        $('#CustomizerName').css('cursor', 'not-allowed');
        $('.adebayo_block_name').css('opacity', '0.75');

        if (digit_one !== '' && digit_two == '') {
            $('#li_tab2').css('pointer-events', 'none');
            $('#li_tab2').css('cursor', 'not-allowed');
            $('#li_tab2').css('opacity', '0.5');
            $('#CustomizerDigit2').val('N/A');

            shiftCanvasIfOneDigit();

            $('.tab_digit_block').click(function (e) {
                ctx.clearRect(180, 310, 115, 300);
                ctx.clearRect(570, 255, 53, 300);
                shiftCanvasIfOneDigit();
            });
        }
    }

    function displayNumberStyles() {
        // display digit 1 row styles, add class to preset number style and create canvas on jersey
        $('.tab_digit_one_row .tab_digit_row[data-row-digit="' + digit_one + '"]').show();
        $('.tab_digit_one_row .tab_digit_row[data-row-digit="' + digit_one + '"] .tab_digit_block[data-style="' + digit_one_style + '"]').addClass('current_num');
        createCanvas1stDigit(digit_one_style, digit_one);

        // display digit 2 row styles, add class to preset number style and create canvas on jersey
        $('.tab_digit_two_row .tab_digit_row[data-row-digit="' + digit_two + '"]').show();
        $('.tab_digit_two_row .tab_digit_row[data-row-digit="' + digit_two + '"] .tab_digit_block[data-style="' + digit_two_style + '"]').addClass('current_num');
        createCanvas2ndDigit(digit_two_style, digit_two);
    }

    // save for later
    function saveForLater() {
        if (save_id == false) {
            $('.select-size').val(size_id);
            $('#CustomizerName').val(name);
            $('#CustomizerDigit1').val(digit_one);
            $('#CustomizerDigit2').val(digit_two);

            $('#name').val(name);
            $('#number1').val(digit_one);
            $('#number1_style').val(digit_one_style);
            $('#number2').val(digit_two);
            $('#number2_style').val(digit_two_style);
            $('.select-size').trigger("change");
          
            $('span#save_for_later_btn').click(function () {
                var customer_check = $('#customer_id').val();
                var product_id = $('#product_id').val();
                var variation_id = $('#size_variation_id').val();
                var customizer_name = $('#name').val();
                var customizer_digit_one = $('#number1').val();
                var customizer_digit_one_style = $('#number1_style').val();
                var customizer_digit_two = $('#number2').val();
                var customizer_digit_two_style = $('#number2_style').val();

                function saveForLaterInsert() {
                    $.ajax({
                        type: 'POST',
                        url: 'https://iamheatnation.com/shopify-mashup-jersey-app/saveforlater_insert.php',
                        data: {
                            customer: customer_check,
                            product: product_id,
                            //id:main_id,
                            size: variation_id,
                            name: customizer_name,
                            number_one: customizer_digit_one,
                            number_one_style: customizer_digit_one_style,
                            number_two: customizer_digit_two,
                            number_two_style: customizer_digit_two_style
                        },
                        success: function (data) {
                            $('#result_data').html(data);
                            window.location = 'https://www.themiamiheatstore.com/pages/save-for-later';
                        },

                        error: function (e) {
                            alert('Error' + e);
                        }
                    });
                }

                if (customer_check == '') {
                    //alert();
                    window.location = 'https://www.themiamiheatstore.com/account';

                    var url = window.location.href;
                    var urlPath = url.substring(url.lastIndexOf('/products') + 1);

                    document.cookie = 'product_id=' + product_id;
                    document.cookie = 'Customize_name=' + customizer_name;
                    document.cookie = 'number_1=' + customizer_digit_one;
                    document.cookie = 'number_1_style=' + customizer_digit_one_style;
                    document.cookie = 'number_2=' + customizer_digit_two;
                    document.cookie = 'number_2_style=' + customizer_digit_two_style;
                    document.cookie = 'size=' + variation_id;
                    document.cookie = 'product_url=https://www.themiamiheatstore.com/' + urlPath + '?name=' + customizer_name + '&num1=' + customizer_digit_one + '&num1_style=' + customizer_digit_one_style + '&num2=' + customizer_digit_two + '&num2_style=' + customizer_digit_two_style + '&size=' + variation_id + '; path=/';
                } else {
                    var allCookies = document.cookie.split(';');
                    // The "expire" attribute of every cookie is
                    // Set to "Thu, 01 Jan 1970 00:00:00 GMT"
                    for (var i = 0; i < allCookies.length; i++) document.cookie = allCookies[i] + '=;expires=' + new Date(0).toUTCString();

                    saveForLaterInsert();
                }
            });
            displayNumberStyles();
        } else {
            $('.select-size').val(size_id);
            $('#CustomizerName').val(name);
            $('#CustomizerDigit1').val(digit_one);
            $('#CustomizerDigit2').val(digit_two);

            $('#name').val(name);
            $('#number1').val(digit_one);
            $('#number1_style').val(digit_one_style);
            $('#number2').val(digit_two);
            $('#number2_style').val(digit_two_style);

            $('.select-size').trigger("change");

            $('span#save_for_later_btn').click(function () {
                var customer_check1 = $('#customer_id').val();
                var product_id1 = $('#product_id').val();
                var variation_id1 = $('#size_variation_id').val();
                var customizer_name1 = $('#name').val();
                var customizer_digit_one1 = $('#number1').val();
                var customizer_digit_one_style1 = $('#number1_style').val();
                var customizer_digit_two1 = $('#number2').val();
                var customizer_digit_two_style1 = $('#number2_style').val();

                function saveForLaterUpdate() {
                    $.ajax({
                        type: 'POST',
                        url: 'https://iamheatnation.com/shopify-mashup-jersey-app/saveforlater_update.php',
                        data: {
                            customer: customer_check1,
                            product: product_id1,
                            id: main_id,
                            size: variation_id1,
                            name: customizer_name1,
                            number_one: customizer_digit_one1,
                            number_one_style: customizer_digit_one_style1,
                            number_two: customizer_digit_two1,
                            number_two_style: customizer_digit_two_style1
                        },
                        success: function (data) {
                            $('#result_data').html(data);
                            window.location = 'https://www.themiamiheatstore.com/pages/save-for-later';
                        }
                    });
                }

                if (customer_check1 == '') {
                    window.location = 'https://www.themiamiheatstore.com/account';
                } else {
                    saveForLaterUpdate();
                }
            });
            displayNumberStyles();
        }
    }

    // init functions
    customizerKeyEvents();
    setTimeout(function () {
        cartSaveBtnsValidation();
        shiftCanvasIfOneDigit();
        checkIfProductIsOnSale();
    }, 300);
    saveForLater();

    
});
